import api from './api';

const multiplayerService = {
  /**
   * Create a new multiplayer room
   */
  createRoom: async (options = {}) => {
    const response = await api.post('/multiplayer/create', options);
    return response.data;
  },

  /**
   * Join an existing room by code
   */
  joinRoom: async (roomCode) => {
    const response = await api.post('/multiplayer/join', { room_code: roomCode.toUpperCase() });
    return response.data;
  },

  /**
   * Get room details
   */
  getRoom: async (roomCode) => {
    const response = await api.get(`/multiplayer/${roomCode}`);
    return response.data;
  },

  /**
   * Leave a room
   */
  leaveRoom: async (roomCode) => {
    const response = await api.post(`/multiplayer/${roomCode}/leave`);
    return response.data;
  },

  /**
   * Start the game (host only)
   */
  startGame: async (roomCode) => {
    const response = await api.post(`/multiplayer/${roomCode}/start`);
    return response.data;
  },

  /**
   * Get round data
   */
  getRound: async (roomCode, roundNumber) => {
    const response = await api.get(`/multiplayer/${roomCode}/round/${roundNumber}`);
    return response.data;
  },

  /**
   * Submit a guess
   */
  submitGuess: async (roomCode, roundNumber, guessData) => {
    const payload = {
      guess_latitude: guessData.latitude !== null && guessData.latitude !== undefined ? parseFloat(guessData.latitude) : null,
      guess_longitude: guessData.longitude !== null && guessData.longitude !== undefined ? parseFloat(guessData.longitude) : null,
      time_taken: guessData.timeTaken !== null && guessData.timeTaken !== undefined ? Math.floor(parseInt(guessData.timeTaken)) : null,
    };
    
    console.log('Submitting guess:', payload);
    
    const response = await api.post(`/multiplayer/${roomCode}/round/${roundNumber}/guess`, payload);
    return response.data;
  },

  /**
   * Force end a round (host only, for timeout)
   */
  forceEndRound: async (roomCode, roundNumber) => {
    const response = await api.post(`/multiplayer/${roomCode}/round/${roundNumber}/end`);
    return response.data;
  },

  /**
   * Start next round (host only)
   */
  nextRound: async (roomCode) => {
    const response = await api.post(`/multiplayer/${roomCode}/next-round`);
    return response.data;
  },

  /**
   * Get final game results
   */
  getResults: async (roomCode) => {
    const response = await api.get(`/multiplayer/${roomCode}/results`);
    return response.data;
  },
};

export default multiplayerService;
